module.exports = __webpack_public_path__ + "static/media/icon-pdf.1a3769cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-pdf.svg
// module id = 557
// module chunks = 0